import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UsersService, UserModel } from 'src/app/Api_Module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Roles } from 'src/app/models/roles.enum';

@Component({
  selector: 'crg-create-user-modal',
  templateUrl: './create-user-modal.component.html',
})
export class CreateUserModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() user: UserModel;
  loading: boolean;
  alert: any;
  updateMode: boolean;
  Roles = Roles;
  @Output() success: EventEmitter<any> = new EventEmitter();
  constructor(private modalService: NgbModal, private usersService: UsersService, private toastr: ToastrService) {

  }

  ngOnInit() {
  }
  openLg(content) {
    if (!!this.user && !!this.user['id'] && this.user['id'] > 0) {
      this.updateMode = true;
    } else {
      this.user = { firstName: '', lastName: '' };
      this.updateMode = false;
    }
    this.modalService.open(content, { size: 'lg' });
  }

  create() {
    this.usersService.post(this.user).subscribe((resp) => {
      this.loading = false;
      this.success.emit(resp);
      this.toastr.success('User created');
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agencyId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  update() {
    this.usersService.put(this.user).subscribe((resp) => {
      this.loading = false;
      this.toastr.success('User updated');
      this.success.emit({ user: this.user });
      // this.alert = { type: 'success', message: 'Created! \n* customer number: ' + this.agencyId };
      this.modalService.dismissAll('success');
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        this.alert = { type: 'danger', message: 'Something went wrong please try again later. `-' + JSON.stringify(error.error) + '`' };
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    this.alert = null;
  }

}
